export const blockIconsSocialSunnyNew = (
	<span className='material-symbols-outlined'>sunny</span>
);
